import { LayoutHOC } from "base/ui/layout/layout";
import { creatTestTarget } from "./testTarget";

export const createTestTargetPage = (layoutHOC: LayoutHOC) => {
  return layoutHOC(creatTestTarget());
};
